import { Injectable } from "@angular/core";
import { WizardContext, WizardTab } from "controls";

@Injectable()
export class WizardContextImpl extends WizardContext {
    private lastTabId: number = 0;
    private tabs = new Array<WizardTab>();
    private urls = new Array<string>();
    private toolbarVisible = true;
    private requestFeaturesTemplate: any;
    private lastModelListenerId: number = 0;
    private modelListeners = new Map<number, () => void>();
    private userData = new Map<string, any>();

    getTabs(): Array<WizardTab> {
        return this.tabs;
    }

    registerTab(tab: WizardTab): void {
        tab.id = ++this.lastTabId;
        this.tabs.push(tab);
    }

    getDataURLs(): Array<string> {
        return this.urls;
    }

    registerDataURL(url: string): void {
        this.urls.push(url);
    }

    getToolbarVisible(): boolean {
        return this.toolbarVisible;
    }

    setToolbarVisible(toolbarVisible: boolean): void {
        this.toolbarVisible = toolbarVisible;
    }

    getRequestFeaturesTemplate(): any {
        return this.requestFeaturesTemplate;
    }

    setRequestFeaturesTemplate(requestFeaturesTemplate: any): void {
        this.requestFeaturesTemplate = requestFeaturesTemplate;
    }

    registerModelListener(listener: () => void): number {
        const id = ++this.lastModelListenerId;
        this.modelListeners.set(id, listener);
        return id;
    }

    unregisterModelListener(listenerId: number) {
        this.modelListeners.delete(listenerId);
    }

    notifyModelListeners() {
        for (const x of this.modelListeners) {
            x[1]();
        }
    }

    getUserData<T>(key: string): T | undefined {
        return this.userData.get(key);
    }

    setUserData<T>(key: string, value: T) {
        this.userData.set(key, value);
    }
}
